<ng-container *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title>Select Complimentary AOPA Magazine</h1>
  <mat-dialog-content [formGroup]='formGroup'>
    <div class="form-container">
      <div class="select-magazine-dialog__description">Your business is eligible to receive a complimentary AOPA Magazine. Please choose your magazine from the
        drop down choices below. Magazines will be sent to your shipping address.</div>
      <mat-form-field>
        <mat-select placeholder="Select Magazine" formControlName="magType">
          <mat-option value="NoMag">No Magazine</mat-option>
          <mat-option value="AOPAFlightTraining">AOPA Flight Training</mat-option>
          <mat-option value="AOPAPilot">AOPA Pilot</mat-option>
          <mat-option value="AOPATurbinePilot">AOPA Turbine Pilot</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onSubmit()" [disabled]="!formGroup.valid">Submit</button>
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-container>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner class="spinner" [diameter]="200" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
